import styled from "styled-components";
import SideBanner from "assets/images/left-container-banner.jpg";

export const BodyContainer = styled.div``;
export const FormContainer = styled.div`
  max-width: 460px;
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;

  .back-to-login {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: center;
    font-size: 14px;
    line-height: 19px;
    color: #0a5587;
    cursor: pointer;
    margin-top: 15px;
  }
`;
export const LogoWrapper = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.login {
    margin-bottom: 75px;
  }
  svg {
    width: 327px;
  }
  &.for-forget-password {
    margin-bottom: 20px;
  }
  /* &.for-create-account {
    margin-bottom: 20px;
    text-align: center;
  } */
`;
export const Heading = styled.h4`
  color: #1d2e88;
  font-weight: 700;
  font-size: 22px;
  padding-bottom: 30px;
`;
export const ForgotEmailHeading = styled.span`
  color: #6f7172;
  font-size: 23px;
`;
export const ForgotEmailSection = styled.div`
  margin-top: 25px;
`;
export const BackLogo = styled.div`
  padding-bottom: 27px;
  margin: 0;
  img {
    cursor: pointer;
    position: absolute;
    top: 29%;
  }
  img:hover {
    opacity: 0.6;
  }
`;

export const FormBody = styled.div`
  &.create-account-form {
    max-height: calc(100vh - 217px);
    overflow: auto;
    padding: 0 15px;
    margin: 0 auto;
    /* width */
    .w-100 {
      width: 100%;
    }
    .header-heading {
      h5 {
        margin: 0;
        font-family: "latobold";
      }
      h6 {
        margin-top: 7px;
      }
    }
    /* ::-webkit-scrollbar {
      width: 7px;
    }

    /* Track */
    /* ::-webkit-scrollbar-track {
      background: #f4f4f4;
      border-radius: 10px;
    } */

    /* Handle */
    /* ::-webkit-scrollbar-thumb {
      background: #969696;
      border-radius: 10px;
    } */

    /* Handle on hover */
    /* ::-webkit-scrollbar-thumb:hover {
      background: rgba(112, 112, 112, 0.5);
    }  */
    .displayShow {
      display: block;
    }
    .displayHide {
      display: none;
    }
  }
  @media (max-width: 1222px) {
    &.create-account-form {
      max-height: calc(100vh - 250px);
    }
  }
`;
export const Footer = styled.div`
  margin-top: clamp(15px, 1.042vw, 20px);
  /* margin-bottom: 24px; */
  button {
    /* width: 100%; */
    /* max-width: 272px; */
    margin: 0 auto;
    height: clamp(30px, 1.875vw, 36px);
    padding: 0 20px;
    border-radius: 5px;
    background: linear-gradient(180deg, #61b01f 0, #27911b) !important;
    font-size: clamp(12px, 0.833vw, 16px) !important;
  }
  button:hover {
    // opacity: 0.4;
  }
`;
export const AccountContainer = styled.div`
  display: flex;
  width: 100%;

  align-items: center;
`;
export const RegistrationContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  /* max-width: 430px; */
  width: 100%;
  margin: 0 auto;
  .key-icon {
    margin: 0 auto;
    margin-bottom: 20px;
  }
  .setup-password {
    max-height: calc(100vh - 194px);
    overflow: auto;
    padding-right: 10px;
  }
  &.verify-email {
    max-width: 489px;
  }
  a {
    color: #6f7172;
  }
  .RememberSection {
  }
  /* @media (max-height: 570px) {
    .setup-password {
      max-height: calc(100vh - 265px);
    }
  } */
`;
export const ForgotPassword = styled.div``;
export const IconInputField = styled.div`
  margin-bottom: 30px;
  padding-top: 14px;
  position: relative;
  input {
    text-align: left;
    font-size: 14px;
    padding: 14px 41.5px;
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    border-bottom-style: 1px solid #c9c9c9;
    width: 100%;
    max-width: 370px;
    background: unset;
    ::placeholder {
      font-size: 14px;
      color: #9d9d9d;
    }

    :-ms-input-placeholder {
      font-size: 14px;
      color: #9d9d9d;
    }

    ::-ms-input-placeholder {
      font-size: 14px;
      color: #9d9d9d;
    }
    :focus-visible {
      outline: unset;
    }
  }

  Button {
    background: #9d9d9d;
  }
  .emailIcon {
    position: absolute;
    top: 18px;
    left: 12px;
    width: 15px;
    height: 15px;
  }
  .startIcon {
    position: absolute;
    top: 15px;
    left: 13px;
    width: 15px;
    height: 15px;
  }
  .passwordIcon {
    position: absolute;
    top: 13px;
    right: 13px;
    cursor: pointer;
  }
`;
export const InputField = styled.div`
  margin-bottom: 30px;
  position: relative;
  width: 100%;
  &.error-msg-window {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .label {
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.005em;
    color: #707070;
    opacity: 0.5;
    margin-bottom: 8px;
  }
  input {
    /* font-family: "poppinsRegular"; */
    text-align: left;
    font-size: 14px;
    padding: 6px 10px 6px 0;
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    border-bottom: 2px solid #e0e0e0;
    width: 100%;

    background: unset;
    ::placeholder {
      font-size: 14px;
      color: #9d9d9d;
    }

    :-ms-input-placeholder {
      font-size: 14px;
      color: #9d9d9d;
    }

    ::-ms-input-placeholder {
      font-size: 14px;
      color: #9d9d9d;
    }
    :focus-visible {
      outline: unset;
    }
  }

  Button {
    background: #9d9d9d;
  }
  .emailIcon {
    position: absolute;
    top: 18px;
    left: 12px;
    width: 15px;
    height: 15px;
  }
  .startIcon {
    position: absolute;
    top: 15px;
    left: 13px;
    width: 15px;
    height: 15px;
  }
  .passwordIcon {
    position: absolute;
    right: 13px;
    bottom: 13px;
    cursor: pointer;
  }
`;
export const CheckBoxInputField = styled.div`
  margin-bottom: 0px;
  position: relative;
  width: 100%;
  &.error-msg-window {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .label {
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.005em;
    color: #707070;
    opacity: 0.5;
    margin-bottom: 8px;
  }
`;
export const Container = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  > div {
    flex: 1;
    max-width: 50%;
  }
`;
export const LeftSideContainer = styled.div`
  background-image: url(${SideBanner});
  background-position: top;
  background-size: cover;
  /* > img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  } */
`;
export const RightContainer = styled.div`
  display: flex;
  flex: 1 1 0%;
  position: relative;
  padding: 20px;
  align-items: center;
  &.for-create-account,
  &.setup-password {
    justify-content: center;
    /* padding: 50px 10px 20px; */
  }

  /* @media (max-height: 570px) {
    &.for-create-account,
    &.setup-password {
      padding: 30px 30px 20px;
    }
  } */
`;

export const CreateAccountContainer = styled.div`
  width: 100%;
  padding: 0 10px;
  max-width: 851px;
  margin: 0 auto;

  .tc-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const CreateAccountFormWrapper = styled.div`
  .input-wrapper-heading {
    /* font-size: 16px;
    line-height: 18px; */
    letter-spacing: 0.005em;
    font-family: "latobold";
    margin-bottom: 26px;
    margin-top: 15px;
    font-family: "latobold";
  }
  .star {
    color: red;
  }
  .star {
    color: red;
  }
  .header-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 22px;
    /* padding: 0 15px; */
    gap: 10px;
    h5 {
      font-size: 20px;
      line-height: 26px;
      font-family: "latobold";
      margin-bottom: 15px;
    }
    h6 {
      font-size: 14px;
      line-height: 19px;
      font-weight: normal;
      margin-top: 16px;
      span {
        color: #0a5587;
        font-family: "latosemibold";
        cursor: pointer;
      }
    }
    p {
      font-size: 18px;
      line-height: 24px;
    }
    @media (max-width: 1222px) {
      flex-direction: column;
      gap: 0;
    }
  }
  .input-wrapper {
    display: flex;
    gap: clamp(20px, 3.125vw, 60px);
    .app-input-text {
      textarea {
        resize: none;
        width: 100%;
        border: 2px solid #e0e0e0;
        height: 122px;
        padding: 5px;
      }
    }
    .react-select__control {
      /* padding-top: 12px; */
      border: none;
      border-bottom: 2px solid #e0e0e0;
      box-shadow: none;
      :hover {
        border-bottom: 2px solid #e0e0e0;
      }
    }
  }
  .full-width {
    flex-direction: column;
    gap: 0;
  }
`;
